import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { init } from '@/api/Global'
import axios from 'axios';
import { parseQueryString } from './utils/util';

const inIframe = () => {
  return ((window.top !== window) || (window.parent !== window)) && parseQueryString().appId !== 'preview';
};
if (!inIframe()) {
  const defaultStyle = document.getElementById('defaultStyle');
  defaultStyle?.parentNode?.removeChild(defaultStyle);
}

const start = async () => {
  const { data } = await axios.get('/api/v1/system/dictionaries', {
    params: {
      category: 'sys_config',
      keycode: 'client_config',
    },
  });
  init({
    consoleId: data?.value_json?.consoleId,
    VUE_APP_MAIN_DOMAIN: data?.value_json?.mainDomain,
    ssoLoginSubDomain: data?.value_json?.ssoLoginSubDomain,
    panelId: data?.value_json?.panelId,
    consoleLoginSubDomain: data?.value_json?.consoleLoginSubDomain,
    protocol: data?.value_json?.protocol,
    panelDomain: data?.value_json?.panelDomain,
  });
  (await import('./boot')).default();
};
start();

export {}
